"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Text = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Text"));
var _Stack = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Stack"));
var _Separator2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Separator"));
var _mediaQuery = _interopRequireDefault(require("@kiwicom/orbit-components/lib/utils/mediaQuery"));
var _Theme = require("../../../../../records/Theme");
var _jsxRuntime = require("react/jsx-runtime");
var _Separator;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const CategoryWrapper = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "Cookie__CategoryWrapper",
  componentId: "sc-1f04iyo-0"
})(["width:100%;", ""], _mediaQuery.default.tablet((0, _styledComponents.css)(["max-width:220px;"])));
CategoryWrapper.defaultProps = {
  theme: _Theme.themeDefault
};
const Cookie = ({
  category,
  description,
  children,
  borderOff
}) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
    flex: true,
    direction: "column",
    justify: "between",
    tablet: {
      direction: "row"
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(CategoryWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
        weight: "bold",
        spaceAfter: "small",
        children: category
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
      flex: true,
      shrink: true,
      direction: "column",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
        spaceAfter: "medium",
        size: "small",
        children: description
      }), children, !borderOff && (_Separator || (_Separator = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Separator2.default, {})))]
    })]
  });
};
var _default = Cookie;
exports.default = _default;